import type { CraRateSet } from "./types.js";

// CRA rate set effective 20 March 2026 — the most recent biannual (CPI)
// indexation. DATE-KEYED, not FY-keyed: CRA indexes 20 March + 20 September.
// Never edit a shipped rate set to "fix" a later period — author a new
// `rates-YYYY-MM-DD.ts` for the next indexation date.
//
// Figures (figure-ledger AGENT_VERIFIED, rent-assistance-{estimator,attach-
// checker}-figures.md, verified 2026-06-22):
//  - taper 75c/$1 above the minimum threshold (ledgers #2 / #10).
//  - single, no children: MAX **$215.40/fn**, MIN threshold **$152.00/fn**
//    (ledgers #3 / #4). The $219.40 "+$4 boost" content-farm figure is REJECTED;
//    the scout's $154.80 threshold was stale and is corrected to $152.00.
//  - single sharer max $143.60 (attach #6); couple no children max $203.00,
//    threshold $246.20 (attach #7); with-children (via FTB Part A) max $253.12
//    (1–2 ch) / threshold from attach #8/#9 — these family rows are
//    single-secondary, lower confidence (flagged for P4 re-fetch of SSG
//    5.1.7.10), and out of the estimator's core flow.
//
// Govt supplement: $0 affiliate, no product handoff anywhere in this module.
export const rates_2026_03_20: CraRateSet = {
  effectiveFrom: "2026-03-20",
  effectiveTo: null, // current period until the 20 Sep 2026 indexation supersedes it
  label: "CRA rates effective 20 March 2026",
  sources: {
    ssg: "https://guides.dss.gov.au/social-security-guide/5/1/7/10",
    servicesAustralia:
      "https://www.servicesaustralia.gov.au/how-much-rent-assistance-you-can-get",
  },
  sourcesVerifiedAt: "2026-06-22",
  // 75c for every $1 of rent above the minimum threshold (SSG 5.1.7.10).
  taperRate: 0.75,
  rows: {
    // CORE figure — directive-verified. MAX $215.40 (NOT $219.40), MIN $152.00.
    single_no_children: { minRentThreshold: 152.0, maxRate: 215.4 },
    // Single sharer: lower max (~2/3 of single). Single-secondary source.
    single_sharer_no_children: { minRentThreshold: 152.0, maxRate: 143.6 },
    // Couple, no children — combined max $203.00, threshold $246.20.
    couple_no_children: { minRentThreshold: 246.2, maxRate: 203.0 },
    // With-children rows run via FTB Part A. Lower-confidence (single secondary
    // table; flagged for P4). 1–2 children figures used as the representative
    // family row; 3+ children differs (max $286.02) — surfaced as an edge case
    // in copy rather than as a distinct calc row.
    single_with_children: { minRentThreshold: 199.5, maxRate: 253.12 },
    couple_with_children: { minRentThreshold: 294.98, maxRate: 253.12 },
  },
};
